import { CommonModule } from '@angular/common';
import { Component, inject, Injectable, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';

interface ProgressOptions {
  type?: 'determinate' | 'indeterminate';
  modal: boolean;
  value?: number;
  label?: string;
}

@Component({
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid">
      <circle class="ft-track" cx="50" cy="50" r="40" />
      <circle
        class="ft-bar"
        [ngClass]="'ft-bar--' + (data.type || 'indeterminate')"
        cx="50"
        cy="50"
        r="40"
        [ngStyle]="{
          'stroke-dashoffset':
            data.type === 'determinate'
              ? 'calc((3.14159265 * 40 * 2 * (100 - ' +
                (data.value || 0) +
                ')) / 100)'
              : null
        }"></circle>
    </svg>
    <div class="ft-label">{{ data.label }}</div>
  `
})
export class ProgressDialogComponent {
  public readonly data = inject<ProgressOptions>(MAT_DIALOG_DATA);
}

@Injectable({
  providedIn: 'root'
})
export class ProgressService {
  private readonly dialog = inject(MatDialog);
  private dialogRef!: MatDialogRef<ProgressDialogComponent>;

  constructor() {}

  public show(options: ProgressOptions): void {
    this.dialogRef = this.dialog.open(ProgressDialogComponent, {
      data: { options },
      panelClass: ['ft-progress-dialog'],
      autoFocus: false,
      disableClose: options?.modal
    });
  }
  public hide(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
